


































import {
  getSectionsWithRowsFromInputValues,
  getSummaryValues,
  getSummaryValuesPriceEnabled,
} from '@getaccept/editor-lib/src/helpers/pricing-table/editor-node-pricing-table.helper';
import type { PricingTable, MergeValues } from '@getaccept/editor-lib';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { EBlockWidth, Context } from '@getaccept/editor-lib';
import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import EditorNodeWrapper from '../EditorNodeWrapper.vue';
import PricingTableSection from './PricingTableSection.vue';
import PricingTablePriceSummary from './PricingTablePriceSummary.vue';

export default defineComponent({
  name: 'EditorNodePricingTable',
  components: {
    PricingTablePriceSummary,
    PricingTableSection,
    EditorNodeWrapper,
  },
  props: {
    node: { type: Object as PropType<PricingTable>, default: () => ({}) },
    mergeValues: { type: Object as PropType<MergeValues>, required: true },
    blockWidthClass: {
      type: String as PropType<EBlockWidth>,
      default: null,
    },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
    recipient: {
      type: Object as PropType<Recipient>,
      default: () => ({}),
    },
    context: { type: String as PropType<Context>, default: () => Context.Document },
  },
  setup(props) {
    const fieldsWithInput = computed(() => {
      return (
        props.node.fields?.map(field => ({
          ...field,
          value:
            props.recipientInput?.find(input => input.fieldId === field.id)?.value || field.value,
        })) || []
      );
    });

    const isBlockWidthSmall = computed(
      () =>
        props.blockWidthClass === EBlockWidth.XXSmall ||
        props.blockWidthClass === EBlockWidth.XSmall
    );

    return {
      getSectionsWithRowsFromInputValues,
      getSummaryValues,
      getSummaryValuesPriceEnabled,
      fieldsWithInput,
      isBlockWidthSmall,
    };
  },
});
